import React from 'react';
import {
  useManagedAccountPageContext,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Context/ManagedAccountPageContext';
import CollectionTabs from 'Components/ComponentLibrary/Components/Uncategorized/CollectionTabs';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import useUserContext from 'Context/UserContext';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';

const useStyles = buildUseStyles('ManagedAccountPageContent', () => ({
  root: {
    display: 'flex',
    justifyContent: ({ isMobile }) => (isMobile ? 'center' : 'flex-start'),
  },
}));

export default function ManagedAccountPageTabs() {
  const isMobile = useMobileLayout();
  const { isAgent } = useUserContext();
  const { logTabsEvent } = useManagedAccountPageEventLogger();
  const classes = useStyles({ isMobile });
  const {
    tabCollection, setTab, currentTab,
  } = useManagedAccountPageContext();

  return (<>
    <Box className={classes.root} test="managed-account-page-tabs">
      <CollectionTabs
        collection={tabCollection}
        onChange={(e, value) => {
          logTabsEvent(`View ${value}`, { isAgent, tab: value });
          setTab(value);
        }}
        value={currentTab}
      />
    </Box>
  </>);
}
